/**
 * @generated SignedSource<<78906f8c3aec5e88d6c4ec0a6643b375>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueActionsPermissions$data = {
  readonly viewerCanClose: boolean;
  readonly viewerCanReopen: boolean;
  readonly " $fragmentType": "IssueActionsPermissions";
};
export type IssueActionsPermissions$key = {
  readonly " $data"?: IssueActionsPermissions$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueActionsPermissions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueActionsPermissions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanClose",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReopen",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "5f54340de4095c22a4db98fc9fd8ee96";

export default node;
